(() => {
  if (customElements.get('pwt-price-shipping')) return;
  customElements.define('pwt-price-shipping', class extends HTMLElement {
    connectedCallback() {
      const source = this.parentElement.querySelector('[data-price-container]');
      if (!source) return;
      const note = this.parentElement.querySelector('[data-pwt-shipping-threshold]');
      const update = () => {
        // Observe the theme's actual selling price, including variant changes.
        // A range or unselected/unavailable price is not a shipping quote.
        const node = source.querySelector('[data-price]');
        if (node) {
          const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
          const matches = [];
          while (walker.nextNode()) {
            const child = walker.currentNode;
            if (!child.parentElement.closest('.pwt-price-tax') && /（税込）|\(税込\)/.test(child.nodeValue)) matches.push(child);
          }
          matches.forEach(child => {
            const fragment = document.createDocumentFragment();
            child.nodeValue.split(/(（税込）|\(税込\))/).forEach(part => {
              if (/^(（税込）|\(税込\))$/.test(part)) {
                const tax = document.createElement('span');
                tax.className = 'pwt-price-tax';
                tax.textContent = part;
                fragment.append(tax);
              } else fragment.append(document.createTextNode(part));
            });
            child.replaceWith(fragment);
          });
        }
        const text = node ? node.textContent.trim() : '';
        const numeric = text.replace(/[^0-9.\-]/g, '');
        const valid = /^\d+(?:\.0+)?$/.test(numeric);
        this.hidden = !valid;
        if (!valid) {
          if (note) note.hidden = true;
          return;
        }
        const free = Number(numeric) >= Number(this.dataset.threshold);
        this.classList.toggle('pwt-shipping-free', free);
        if (note) note.hidden = free;
        this.textContent = free ? '送料無料' : `＋ 送料${this.dataset.fee}円`;
      };
      this.observer = new MutationObserver(update);
      this.observer.observe(source, { childList: true, characterData: true, subtree: true });
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
})();
